import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import EstadoCuentaHeader from './EstadoCuentaHeader';
import EstadoCuentaFiltros from './EstadoCuentaFiltros';
import EstadoCuentaResumen from './EstadoCuentaResumen';
import EstadoCuentaLista from './EstadoCuentaLista';

const PanelEstadoCuenta = ({
    rfcSeleccionado,
    cargando,
    periodoEstadoCuenta,
    setPeriodoEstadoCuenta,
    tipoMovimiento,
    setTipoMovimiento,
    totales,
    movimientosFiltrados,
    handleSeleccionarArchivo,
    cuentasBancarias,
    cuentaSeleccionada,
    setCuentaSeleccionada
}) => {
    return (
        <Card className="shadow-sm h-100">
            <Card.Header className="bg-light border-bottom py-3">
                <EstadoCuentaHeader
                    rfcSeleccionado={rfcSeleccionado}
                    cargando={cargando}
                    handleSeleccionarArchivo={handleSeleccionarArchivo}
                    cuentaSeleccionada={cuentaSeleccionada}
                />
            </Card.Header>

            <EstadoCuentaFiltros
                rfcSeleccionado={rfcSeleccionado}
                periodoEstadoCuenta={periodoEstadoCuenta}
                setPeriodoEstadoCuenta={setPeriodoEstadoCuenta}
                tipoMovimiento={tipoMovimiento}
                setTipoMovimiento={setTipoMovimiento}
                cuentasBancarias={cuentasBancarias}
                cuentaSeleccionada={cuentaSeleccionada}
                setCuentaSeleccionada={setCuentaSeleccionada}
            />

            <Card.Body className="p-0">
                {!cuentaSeleccionada ? (
                    <div className="p-5 text-center">
                        <i className="fas fa-hand-pointer fa-3x text-300 mb-3"></i>
                        <h5 className="text-500">Seleccione una cuenta bancaria</h5>
                        <p className="text-500 mb-0">Elija una cuenta para ver sus movimientos y conciliaciones.</p>
                    </div>
                ) : (
                    <>
                        <EstadoCuentaResumen totales={totales} />
                        <EstadoCuentaLista
                            rfcSeleccionado={rfcSeleccionado}
                            movimientosFiltrados={movimientosFiltrados}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};



PanelEstadoCuenta.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargando: PropTypes.bool,
    periodoEstadoCuenta: PropTypes.instanceOf(Date),
    setPeriodoEstadoCuenta: PropTypes.func,
    tipoMovimiento: PropTypes.string,
    setTipoMovimiento: PropTypes.func,
    totales: PropTypes.object,
    movimientosFiltrados: PropTypes.array,
    handleSeleccionarArchivo: PropTypes.func,
    cuentasBancarias: PropTypes.array,
    cuentaSeleccionada: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setCuentaSeleccionada: PropTypes.func
};

export default PanelEstadoCuenta;
